import { ServiceStatus, type ServiceStatusType } from './types';

import type { StatusType } from '@kc-console/common-ui';

/**
 * 서비스 상태 라벨 맵을 반환한다.
 * @description
 * - 상태값에 대응되는 한국어 라벨을 제공한다.
 * @example
 * const label = getServiceStatusLabelMap()[ServiceStatus.Opened];
 */
export const getServiceStatusLabelMap = (): Record<ServiceStatusType, string> => ({
  [ServiceStatus.Opened]: '확인 필요',
  [ServiceStatus.Processing]: '처리 중',
  [ServiceStatus.Resolved]: '정상',
  [ServiceStatus.Issue]: '이슈 발생',
});

/**
 * 서비스 상태를 `Status` 컴포넌트의 `status` 타입으로 매핑한다.
 * @description
 * - Resolved/Opened/Processing/Issue 이외의 값은 비활성 상태로 처리한다.
 * @example
 * const variant = getServiceStatusVariant(ServiceStatus.Opened);
 */
export const getServiceStatusVariant = (status: ServiceStatusType): StatusType => {
  switch (status) {
    case ServiceStatus.Opened:
      return 'warning';
    case ServiceStatus.Processing:
      return 'error';
    case ServiceStatus.Issue:
      return 'information';
    case ServiceStatus.Resolved:
      return 'active';
    default:
      return 'inactive';
  }
};
